import React from 'react';
import { DEFAULT_LANGUAGE } from './helpers/constants';
const TranslationContext = React.createContext({
    t: p => p,
    formatShortDate: () => '',
    getHelpNoteTooltipTitle: p => p,
    locales: [],
    currentLanguage: DEFAULT_LANGUAGE,
    direction: 'ltr',
    isLayoutRTL: false,
});
export default TranslationContext;
